import { PoliceLight } from "@/types/Police";

export interface Sinistre {
  claimsNumber: number;
  claimsUuid: string | null;
  policy: PoliceLight;
  status: CodeLabelDescription;
  nature: CodeLabelDescription;
  reportingDate: string;
  eventDate: string;
  openingDate: string;
  statusDate: string;
  cost: number;
  customerDescription: string | null;
  claimformLink: string | null;
}
interface CodeLabelDescription {
  code: string;
  label: string | null;
  labelFr: string | null;
  labelEn: string | null;
  description: string | null;
}

export enum StatutSinistreEnum {
  EC = "EC",
  PREDECLA = "PREDECLA",
  PARCOURS = "PARCOURS",
  CLOSTER = "CLOSTER",
  CLOSS = "CLOSS",
}

export type StatutSinistre = StatutSinistreEnum | null;
